import axios from "axios";
import { Party } from "./types";
import { getValidToken } from "../../../utils/authUtils";
export const partyApi = {
  getParties: async () => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}master-data/parties`;
      const token = await getValidToken();
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess && response?.data?.data?.length > 0) {
        return response?.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return [];
    }
  },
  addEditParty: async (party: Party, isEdit: boolean) => {
    try {
      const url = isEdit
        ? `${process.env.REACT_APP_API_HOST}master-data/parties/${party.id}`
        : `${process.env.REACT_APP_API_HOST}master-data/parties`;
      const token = await getValidToken();
      const response = await axios[isEdit ? "put" : "post"](url, party, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return true;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      throw error;
    }
  },
  search: async (searchTerm: string) => {
    try {
      const url = `${
        process.env.REACT_APP_API_HOST
      }master-data/parties?search=${encodeURIComponent(searchTerm)}`;
      const token = await getValidToken();
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  },
};
